module.exports = __webpack_public_path__ + "themify.svg?cba68f986e60df8c74f4a53c3e39595c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.svg?-fvbane
// module id = 923
// module chunks = 27